import { Fragment, createElement, memo } from "react"
import PropTypes from "prop-types"
import { marked } from "marked"
import parse from "html-react-parser"
import {
  gaExternalLink,
  gaInternalLink,
  gePdfDownload,
} from "../../../constants/gtm.constants"

const Typography = ({
  index,
  className,
  component: Component,
  content,
  br_allowed,
  allow_br_tag,
  linkClass = "",
  handleClick = () => {},
  dataActionDetail,
  ...other
}) => {
  const regex = new RegExp(
    "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
  )

  const getLabel = (child) => {
    if(child?.data) return child?.data;
    else if(child?.children?.length > 0) return getLabel(child?.children[0]);
    else return;
}

  const getClassName = (url, target, childClass) => {
    let className = gaInternalLink
    const isExternallink = regex.test(url)
    if (url?.trim()?.endsWith(".pdf") || url?.trim()?.endsWith(".pdf/")) {
      className = gePdfDownload
    } else if (isExternallink) {
      className = gaExternalLink
    } else {
      className = target === "_blank" ? gaExternalLink : gaInternalLink
    }
    return className
  }
  return createElement(
    Component,
    {
      ...(className ? { className } : {}),
      "data-action-detail": `${dataActionDetail}`,
      ...other,
    },
    parse(marked(content || ""), {
      replace: domNode => {
        if (domNode.type === "tag" && domNode.name === "br") {
          return allow_br_tag ? createElement("br") : createElement(Fragment);
        } else if (domNode.type === "tag" && domNode.name === "a") {
          const childClass = domNode?.children?.length > 0 ? domNode?.children[0]?.attribs?.class : "";
          const subClass = domNode?.attribs?.class ? domNode?.attribs?.class : "";
        
          // Process inner elements
          const innerElements = domNode.children.map((child, index) => {
            if (child.type === "tag" && (child.name === "div" || child.name === "span")) {
              return createElement(child.name, { key: index, className: child.attribs.class }, child.children[0]?.data);
            } else {
              return createElement(
                "span",
                { key: index },
                child.data ? child.data : getLabel(child)
              );
            }
          });
        
          return createElement(
            "a",
            {
              className: linkClass
                ? linkClass
                : `${childClass} ${subClass} ${getClassName(
                    domNode?.attribs?.href,
                    domNode?.attribs?.target,
                    childClass
                  )} link-text`,
              "data-action-detail": domNode?.attribs?.href || dataActionDetail,
              id: domNode?.attribs?.id,
              "aria-label": domNode?.attribs["aria-label"]
                ? domNode?.attribs["aria-label"]
                : domNode?.attribs?.href?.split("/")?.pop()?.replaceAll("-", " ") ||
                  domNode?.attribs?.href?.replaceAll("-", " "),
              target: domNode?.attribs?.target,
              href: !domNode?.attribs?.href?.includes(".")
                ? domNode?.attribs?.href?.toLowerCase()
                : domNode?.attribs?.href,
              onClick: () => handleClick(index, domNode.attribs),
            },
            innerElements
          );
        } else if (domNode.type === "tag" && domNode.name === "img") {
          return createElement("img", {
            src: domNode.attribs.src,
            alt: domNode.attribs.alt || "image",
            className: domNode.attribs.class,
          });
        }
      },
      trim: true,
    })
  )
}

Typography.propTypes = {
  className: PropTypes.string,
  component: PropTypes.string,
  content: PropTypes.string,
  br_allowed: PropTypes.bool,
  allow_br_tag: PropTypes.bool,
  linkClass: PropTypes.string,
  handleClick: PropTypes.func,
  index: PropTypes.number,
  dataActionDetail: PropTypes.string,
}

Typography.defaultProps = {
  className: "",
  component: "div",
  content: "",
  br_allowed: true,
  allow_br_tag: false,
}

export default memo(Typography)
